export default __webpack_public_path__ + "static/media/easybar_screen.684cf92a.png";